<template>
  <SeoPillarLandingPage :content="$t('seoPillarAfiliados')" faq-src="/seo-faq/encurtador-de-link-para-afiliados.json"/>
</template>
<script>
import SeoPillarLandingPage from "../fragments/SeoPillarLandingPage.vue";
export default {
  name: 'PillarEncurtadorAfiliados',
  components: { SeoPillarLandingPage },
}
</script>
